import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { selectVehiclesQueryItems } from '../../../../../redux/vehicles/selector';
import { selectAgentsListItems } from '../../../../../redux/agents/selector';
import { selectTransportersListItems } from '../../../../../redux/transporters/selector';
import { vehicles } from '../../../../../redux/vehicles/action';
import { agents } from '../../../../../redux/agents/action';
import { transporters } from '../../../../../redux/transporters/action';
import PageLoader from '../../../../../components/PageLoader';
import VehicleComponent from '../components/vehicle.component';


const ManagementVehicle = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const vehicleQuery = useSelector(selectVehiclesQueryItems)
  const transportAgentListItems = useSelector(selectAgentsListItems)
  const transporterListItems = useSelector(selectTransportersListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedVehicle,
    setSelectedVehicle
  ] = useState<any>([])


  const fetchVehicleById = () => {
    dispatch(vehicles.query({
      url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/rap-manager/vehicles/query`, entity: 'vehicles', jsonData: {

        Records: [
          {
            Id: parmas?.id
          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    }).then(() => {
      setIsLoading(false)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedVehicle({ ...selectedVehicle, [field]: event });
  }

  useEffect(
    () => {
      dispatch(agents.list({
        url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/rap-manager/agents/list`, entity: 'agents', jsonData: {

        }
      })).then(() => {
        dispatch(transporters.list({
          url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/rap-manager/raps/list`, entity: 'transporters', jsonData: {

          }
        }))
      }).then(() => {
        if (parmas?.id > 0) {
          fetchVehicleById()
          setIsLoading(false)
        } else {
          setIsLoading(false)

        }
      })
    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        setSelectedVehicle(vehicleQuery?.result?.items)
      }
    },
    [isQuery]
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      dispatch(vehicles.update({
        url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/rap-manager/vehicles`, entity: 'vehicles', jsonData: {

          Records: [
            selectedVehicle
          ]

        }
      })).then(() => {
        back()
      });

    } else {
      dispatch(vehicles.create({
        url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/rap-manager/vehicles`, entity: 'vehicles', jsonData: {

          Records: [
            selectedVehicle
          ]

        }
      })).then(() => {
        back()
      });
    }
  }

  const back = () => {
    navigate('/management/rap-manager/vehicles')
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <VehicleComponent
          handleInnerFormChange={handleInnerFormChange}
          selectedVehicle={selectedVehicle}
          transportAgents={transportAgentListItems?.result?.items}
          transporters={transporterListItems?.result?.items}
          back={back}
          handleFormSubmit={handleFormSubmit}
        />
      }
    </>
  )

}

export default ManagementVehicle;